import { definePlugin } from "/@src/utils/plugins";

export default definePlugin(async ({ router }) => {
  const userSession = useUserSession();

  // Get the user session from supabase
  await userSession.getSession();

  router.beforeEach((to) => {
    if (to.meta.requiresAuth && !userSession.isLoggedIn) {
      return {
        path: "/auth",
        query: { redirect: to.fullPath },
      };
    }
  });
});
